// Config
const enableUpdateNBDonFrequencyUpdate = true;
const enableCustomTwoWeeksDatePicker = true;
const disableConditionalEditNBD = false;

// Bundle app settings
window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: { productImage: 600 }
});

const waitForElement = (selector, callback, delay = 0, failsafeDelay) => {
  const observer = new MutationObserver((mutations, obs) => {
    const element = document.querySelector(selector);
    if (element) {
      obs.disconnect();
      if (typeof callback === "function") {
        setTimeout(() => {
          callback(element);
        }, delay);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (failsafeDelay) setTimeout(() => observer.disconnect(), failsafeDelay);
};

//if awtomic customer portal
if (window.location.pathname.includes("/tools/bundle-subscriptions") && window.location.search.includes("subscriptionId=")) {
  document.body.classList.add("awt-cp");

  // Check if customer has orders within last 8 weeks
  const haveOrdersWithinLastEightWeeks = () => {
    const successfulBillingAttempts = window.Awtomic.subscriptionBillingAttempts.filter((ba) => ba.BillingAttemptStatus == "SUCCESS");
    const eightWeeksAgo = new Date();
    eightWeeksAgo.setDate(eightWeeksAgo.getDate() - 56);
    return successfulBillingAttempts.some((ba) => new Date(ba.CompletedAt).getTime() >= eightWeeksAgo.getTime());
  };

  // Disable skip and pause buttons for inactive customers
  const disableSkipAndPause = () => {
    const style = document.createElement("style");
    style.textContent = `
    .bundle-button--pause,
    .bundle-card--next-order-date .button--secondary,
    .bundle-button--skip {
      opacity: 0 !important;
      cursor: not-allowed !important;
      pointer-events: none !important;
    }
    ${
      disableConditionalEditNBD
        ? `.bundle-card--next-order-date .bundle-card__button {
      opacity: 0 !important;
      cursor: not-allowed !important;
      pointer-events: none !important;
    }`
        : ""
    }
  `;
    document.body.appendChild(style);

    const pauseButton = document.querySelector(".bundle-button--pause");
    if (pauseButton) {
      const message = document.createElement("p");
      message.textContent = "To remain a member you must place an order at least once every 8 weeks";
      message.style.cssText = "color: red; font-size: 14px; margin-bottom: 10px;";
      pauseButton.parentNode.insertBefore(message, pauseButton);
      pauseButton.setAttribute("disabled", "true");
    }

    document.querySelector(".bundle-card--next-order-date .button--secondary")?.setAttribute("disabled", "true");
    if (disableConditionalEditNBD) document.querySelector(".bundle-card--next-order-date .bundle-card__button")?.setAttribute("disabled", "true");
    document.querySelectorAll(".bundle-button--skip").forEach((btn) => btn.setAttribute("disabled", "true"));
  };

  // Prompt user to update next billing date when frequency changes
  const updateNBDonFrequencyUpdate = () => {
    const frequencyApiPattern = /https:\/\/shapi\.bundlepayments\.com\/customers\/(\d+)\/subscriptions\/(\d+)\/frequency/;
    let capturedAuthToken = null;

    const handleFrequencyApiCall = (customerId, subscriptionId, response, authToken) => {
      capturedAuthToken = authToken;
      if (!response?.BillingIntervalBillingCount) return;

      const [type, value] = response.BillingIntervalBillingCount.split("#");
      const count = parseInt(value);
      const completedAt = window.Awtomic?.subscriptionBillingAttempts?.[0]?.CompletedAt || window.Awtomic?.subscriptionDetails?.CreatedAt;

      if (completedAt) {
        const startDate = new Date(completedAt);
        let nextDate = new Date(startDate);

        if (type === "DAY") nextDate.setDate(nextDate.getDate() + count);
        else if (type === "WEEK") nextDate.setDate(nextDate.getDate() + count * 7);
        else if (type === "MONTH") nextDate.setMonth(nextDate.getMonth() + count);

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (nextDate < today) {
          nextDate = new Date();
          nextDate.setDate(nextDate.getDate() + 1);
          nextDate.setHours(0, 0, 0, 0);
        }

        const formattedDate = nextDate.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
        const apiDate = `${nextDate.getFullYear()}-${String(nextDate.getMonth() + 1).padStart(2, "0")}-${String(nextDate.getDate()).padStart(2, "0")}`;

        const modal = document.createElement("div");
        modal.style.cssText =
          "position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(99, 115, 129, 0.25); display: flex; align-items: center; justify-content: center; z-index: 10000; backdrop-filter: blur(2px);";
        modal.innerHTML = `
        <div style="background: white; padding: 50px 40px; border-radius: 5px; max-width: 500px; text-align: center; box-shadow: 0 4px 20px rgba(0,0,0,0.15);">
          <h3 style="margin-bottom: 25px; font-family: 'canela-light', serif; font-size: 28px; font-weight: 400; color: #333; line-height: 1.3;">Update Next Billing Date?</h3>
          <p style="margin-bottom: 35px; font-family: 'Futura', sans-serif; font-size: 15px; line-height: 1.6; color: #666;">Would you like to also update your next billing date to <strong style="color: #333;">${formattedDate}</strong>?</p>
          <div style="display: flex; gap: 15px; justify-content: center; flex-wrap: wrap;">
            <button id="nbd-yes" style="appearance: none; display: flex; align-items: center; justify-content: center; text-transform: uppercase; font-size: 12px; font-family: Jost, sans-serif; font-weight: 600; letter-spacing: 1.5px; line-height: 22.8px; padding: 8px; min-height: 30px; min-width: 78px; border-radius: 5px; background: rgb(164, 145, 92); color: rgb(255, 255, 255); border: none; cursor: pointer; box-sizing: border-box;">YES</button>
            <button id="nbd-no" style="appearance: none; display: flex; align-items: center; justify-content: center; text-transform: uppercase; font-size: 12px; font-family: Jost, sans-serif; font-weight: 600; letter-spacing: 1.5px; line-height: 22.8px; padding: 8px; min-height: 30px; min-width: 78px; border-radius: 5px; background: rgb(164, 145, 92); color: rgb(255, 255, 255); border: none; cursor: pointer; box-sizing: border-box;">NO</button>
          </div>
        </div>
      `;

        document.body.appendChild(modal);

        document.getElementById("nbd-yes").addEventListener("click", async () => {
          try {
            await fetch(`https://shapi.bundlepayments.com/customers/${customerId}/subscriptions/${subscriptionId}/next-billing-date`, {
              method: "POST",
              headers: { "Content-Type": "application/json", authorization: capturedAuthToken },
              body: JSON.stringify({ nextBillingDate: apiDate, eventType: "UPDATED_ORDER_DATE" })
            });
          } catch (error) {
            console.error("Error updating NBD:", error);
          }
          window.location.reload();
        });

        document.getElementById("nbd-no").addEventListener("click", () => document.body.removeChild(modal));
      }
    };

    const originalFetch = window.fetch;
    window.fetch = (...args) => {
      const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";
      const match = url.match(frequencyApiPattern);

      if (match) {
        const [, customerId, subscriptionId] = match;
        const authToken = args[1]?.headers?.authorization || args[1]?.headers?.Authorization;

        return originalFetch(...args).then((response) => {
          response
            .clone()
            .json()
            .then((data) => handleFrequencyApiCall(customerId, subscriptionId, data, authToken))
            .catch(() => {});
          return response;
        });
      }

      return originalFetch(...args);
    };
  };

  // Initialize custom date picker (2 weeks max)
  const initCustomDatePicker = () => {
    const datePickerObserver = new MutationObserver(() => {
      const datePickerInput = document.querySelector('.awt-nbd-code-container .react-datepicker__input-container input[data-testid="awt-date-picker-input"]');
      if (!datePickerInput || datePickerInput.hasAttribute("data-cloned")) return;

      const parentForm = datePickerInput.closest("form");
      const bundleappFlexDiv = parentForm?.querySelector(".bundleapp-flex");

      if (bundleappFlexDiv && !parentForm.querySelector(".awt-custom-date-picker")) {
        bundleappFlexDiv.style.cssText = "visibility: hidden; position: absolute; opacity: 0;";
        parentForm.style.width = "100%";

        const dateDiv = document.createElement("div");
        dateDiv.className = "awt-custom-date-picker";

        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        tomorrow.setHours(0, 0, 0, 0);
        const minDate = tomorrow.toISOString().split("T")[0];
        const minDateTime = tomorrow.getTime();

        const currentNextBillingDate = new Date(datePickerInput.value);
        const maxBillingDate = new Date(currentNextBillingDate.getTime() + 14 * 24 * 60 * 60 * 1000);
        maxBillingDate.setHours(23, 59, 59, 999);
        const maxDate = maxBillingDate.toISOString().split("T")[0];
        const maxDateTime = maxBillingDate.getTime();

        dateDiv.innerHTML = `<input type="date" id="custom-date-input" min="${minDate}" max="${maxDate}" style="margin-bottom: 9px; cursor: pointer; width: 100%; border-radius: 10px; padding: 5px 10px;"/>`;

        const customInput = dateDiv.querySelector("input");
        customInput.valueAsDate = new Date(datePickerInput.value);

        // Enforce min/max on mobile (mobile browsers don't always respect min/max attributes)
        customInput.addEventListener("change", function () {
          const selectedDate = this.valueAsDate;
          if (selectedDate) {
            const selectedTime = selectedDate.getTime();
            const formattedMaxDate = maxBillingDate.toLocaleDateString(navigator.language, {
              month: 'long',
              day: 'numeric',
              year: 'numeric',
            });

            if (selectedTime < minDateTime) {
              alert(`Looks like that date is behind our pour schedule 🍾\nPlease select a delivery date on or before ${formattedMaxDate}.`);
              this.valueAsDate = tomorrow;
            } else if (selectedTime > maxDateTime) {
              alert(`Looks like that date is ahead of our pour schedule 🍾\nPlease select a delivery date on or before ${formattedMaxDate}.`);
              this.valueAsDate = maxBillingDate;
            }
          }
        });

        const urlParams = new URLSearchParams(window.location.search);
        const subscriptionId = urlParams.get("subscriptionId");
        const customerId = (window.Awtomic?.subscriptionDetails?.CustomerId || "").split("/").pop();

        setTimeout(() => {
          parentForm.prepend(dateDiv);

          const saveButton = parentForm.querySelector('button[type="submit"]');
          const bundleCard = parentForm.closest(".bundle-card");

          saveButton?.addEventListener("click", async (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (bundleCard) bundleCard.style.cssText = "pointer-events: none; opacity: 0.6;";

            const selectedDate = customInput.valueAsDate;
            if (selectedDate) {
              const isoValue = selectedDate.toISOString().split("T")[0];
              const authToken = JSON.parse(localStorage.getItem("awtomicApiAuth") || "{}").authToken;

              try {
                const response = await fetch(`https://shapi.bundlepayments.com/customers/${customerId}/subscriptions/${subscriptionId}/next-billing-date?`, {
                  method: "POST",
                  headers: { "content-type": "application/json", authorization: authToken },
                  body: JSON.stringify({ nextBillingDate: isoValue, eventType: "UPDATED_ORDER_DATE" })
                });

                if (response.ok) {
                  window.location.reload();
                } else {
                  if (bundleCard) bundleCard.style.cssText = "pointer-events: auto; opacity: 1;";
                }
              } catch (error) {
                console.error("Error updating date:", error);
                if (bundleCard) bundleCard.style.cssText = "pointer-events: auto; opacity: 1;";
              }
            }
          });
        }, 1);

        datePickerInput.setAttribute("data-cloned", "true");
      }
    });

    datePickerObserver.observe(document.body, { childList: true, subtree: true });
  };

  // Initialize when Awtomic customer portal loads
  window.addEventListener("awtomic-cp-loaded", () => {
    setTimeout(() => {
      if (!haveOrdersWithinLastEightWeeks()) disableSkipAndPause();
      if (enableUpdateNBDonFrequencyUpdate) updateNBDonFrequencyUpdate();
      if (enableCustomTwoWeeksDatePicker) initCustomDatePicker();
    }, 200);
  });
}

// Remove Dynamic Box from cart
document.body.addEventListener("click", async (event) => {
  const trigger = event.target.closest(".cart__remove-dynamic-box");
  if (!trigger) return;

  const boxIndex = trigger.getAttribute("data-dynamic-box-index");
  const boxId    = trigger.getAttribute("data-dynamic-box-id");
  if (boxIndex == null) return;

  event.preventDefault();
  try {
    const cart = await (await fetch("/cart.js")).json();

    const updates = {};
    cart.items.forEach((item) => {
      const p = item.properties || {};
      const idxMatch = String(p._dynamicBoxIndex) === String(boxIndex);
      const idMatch  = boxId == null || String(p._dynamicBoxId) === String(boxId);
      if (idxMatch && idMatch) updates[item.key] = 0;
    });

    if (!Object.keys(updates).length) {
      console.warn("No matching dynamic-box lines found", { boxId, boxIndex });
      return;
    }

    // /cart/update.js fresh cart pachu aape che
    const updatedCart = await (await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates })
    })).json();

    document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: updatedCart } }));

    // page reload ne badle theme ni cart UI rebuild karo
    document.dispatchEvent(new CustomEvent("cart:build"));
  } catch (error) {
    console.error("Error removing dynamic box:", error);
  }
});

// Remove bundle from cart
document.body.addEventListener("click", async (event) => {
  if (!event.target.matches(".cart__remove-bundle *, .cart__remove-bundle[data-bundle-id]")) return;

  const bundleElement = event.target.closest(".cart__remove-bundle") || (event.target.hasAttribute("data-bundle-id") ? event.target : null);
  const bundleId = bundleElement?.getAttribute("data-bundle-id");

  if (bundleId) {
    event.preventDefault();
    try {
      const cart = await (await fetch("/cart.js")).json();
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          updates: cart.items.reduce((acc, item) => (item.properties?._bundleUid === bundleId ? { ...acc, [item.key]: 0 } : acc), {})
        })
      });
      if (response.ok) window.location.href = "/cart";
    } catch (error) {
      console.error("Error removing bundle:", error);
    }
  }
});

// Edit bundle and redirect
document.body.addEventListener("click", async (event) => {
  if (!event.target.matches(".cart__edit-bundle *, .cart__edit-bundle[data-bundle-id]")) return;

  const bundleElement = event.target.closest(".cart__edit-bundle") || (event.target.hasAttribute("data-bundle-id") ? event.target : null);
  const bundleId = bundleElement?.getAttribute("data-bundle-id");
  const itemIds = bundleElement?.getAttribute("data-itemids")?.split(",").filter(Boolean);

  if (bundleId && itemIds) {
    event.preventDefault();
    try {
      const cart = await (await fetch("/cart.js")).json();
      const bundleItems = cart.items.filter((item) => item.properties?._bundleUid === bundleId);

      if (bundleItems.length === 0) return;

      const baseUrl = "/tools/bundle-subscriptions/bundle/7186247483447?product=wine-club&variant=41334497673271&d=10-p&selling_plan=1700266039&";
      const urlParams = bundleItems.map((item) => `${item.variant_id}=${item.quantity}`).join("&");

      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          updates: itemIds.reduce((acc, itemId) => ({ ...acc, [itemId]: 0 }), {})
        })
      });

      if (response.ok) window.location.href = `${baseUrl}${urlParams}`;
    } catch (error) {
      console.error("Error editing bundle:", error);
    }
  }
});

//if awtomic subs list / my subscriptions
if (/^\/tools\/bundle-subscriptions\/?$/.test(location.pathname) && !location.search) {
  document.body.classList.add("awt-my-subs");
}

//if awtomic bab purchase flow
if (window.location.pathname.includes("/tools/bundle-subscriptions/bundle/")) {
  window.Awtomic = window.Awtomic || {};
  window.Awtomic.getBabSelection = () => {
    //babProductId is in a class of an element, the element is div.bundle-container.pv_xxxxxxx where xxxxxxx is the bab product id
    const babProductId = document
      .querySelector(".bundle-container")
      ?.className.split(" ")
      .find((c) => c.startsWith("pv_"))
      ?.split("_")[1];
    if (!babProductId) return { object: {}, queryString: "" };

    const bundleProductCards = document.querySelectorAll(".bundle-product-card");

    const bundleSelectedProducts = {};
    bundleProductCards.forEach((card) => {
      const productId = card.getAttribute("data-pid");
      const quantityElement = card.querySelector(".bundle-product-card__quantity-button-container > span");
      const quantity = quantityElement ? parseInt(quantityElement.innerHTML) : 0;

      if (productId && quantity > 0) {
        bundleSelectedProducts[productId] = quantity;
      }
    });

    // Create query string format
    const queryString = Object.entries(bundleSelectedProducts)
      .map(([id, quantity]) => `${id}=${quantity}`)
      .join("&");

    // Create full URL with query string
    const currentUrl = window.location.href;
    const separator = currentUrl.includes("?") ? "&" : "?";
    const fullUrl = queryString ? `${currentUrl}${separator}${queryString}` : currentUrl;

    return {
      object: { [babProductId]: bundleSelectedProducts },
      queryString: queryString,
      fullUrl: fullUrl
    };
  };

  const urlParts = window.location.pathname.split("/");
  const bundleId = urlParts[urlParts.length - 1];
  if (bundleId) {
    document.body.classList.add(`awt-bundle-${bundleId}`);
  }

  // Make logo clickable to go home
  waitForElement(
    ".bundleapp-modal__logo",
    (logo) => {
      logo.addEventListener("click", () => (window.location.pathname = "/"));
    },
    0,
    10000
  );
}
